import * as React from 'react';
import { IgcDropdownItemComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * Represents an item in a dropdown list.
 * @slot prefix - Renders content before the item's main content.
 * @slot  - Renders the item's main content.
 * @slot suffix - Renders content after the item's main content.
 * @csspart prefix - The prefix wrapper of the igc-dropdown-item.
 * @csspart content - The main content wrapper of the igc-dropdown-item.
 * @csspart suffix - The suffix wrapper of the igc-dropdown-item.
 * @class
 */
export const IgrDropdownItem = /* @__PURE__ */ createComponent({
  tagName: 'igc-dropdown-item',
  displayName: 'IgrDropdownItem',
  elementClass: Component,
  react: React,
});

export type IgrDropdownItem = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrDropdownItemModule = Component;
